module.exports = __webpack_public_path__ + "static/media/loader.5ba2eb1b.gif";